export const BASE_URL = import.meta.env.VITE_BASE_URL;
export const CAT_URL = import.meta.env.VITE_CAT_URL;

export const API_ROOT = import.meta.env.VITE_API_ROOT;
export const CLIENT_ID = import.meta.env.VITE_AZURE_CLIENT_ID;

//Fair warning, could not get value from import.meta.env to work
export const ADMINS = (import.meta.env.VITE_ADMINS || 'webteam@pon.com').split(
   ',',
);
